// import './css/style.css'
// import Experience from './experience/Experience.j/s'
// import './experience/Experience.js'
import Experience from './experience/Experience.js'

// Setup language switch
const LOCALE = __LOCALE__ || 'nl'
import nl from './i18n/nl.json';
import de from './i18n/de.json';
const locales = { nl, de };
const messages = locales[LOCALE] || locales.nl;


document.documentElement.setAttribute('lang', LOCALE);

// Build a set of all keys from the current locale
const HTML_KEYS = new Set(Object.keys(messages));

document.querySelectorAll("[data-i18n]").forEach(el => {
    const key = el.getAttribute("data-i18n");
    const val = messages[key];
    if (!val) return;
    if (HTML_KEYS.has(key)) el.innerHTML = val;
    else el.textContent = val;
});

// Add navigation interaction on mobile
document.querySelector('.menu.primary').addEventListener("click", function (e) {
    this.classList.toggle('open')
})

// Add extra interaction on mobile for side-panel
const mobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

if (mobile) {
    const sidepanels = document.querySelectorAll('.side-panel')
    for (const sidepanel of sidepanels) {
        const minimize = document.createElement('div');
        minimize.classList.add('minimize');
        sidepanel.insertBefore(minimize, sidepanel.firstChild)
    }
    document.querySelector('.watermark').remove();
}

else {
    document.querySelector("p[data-i18n='disclaimer']").remove()
}

const minimizers = document.querySelectorAll('.minimize')
for (const minimizer of minimizers) {
    minimizer.addEventListener("click", function (e) {
        this.parentElement.classList.toggle('minimized')
    })
}

// Setup experience
const experience = new Experience(document.querySelector('canvas.webgl'))